export class EntraRestoreReport {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "schemaVersion",
            "baseName": "schemaVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "reportType",
            "baseName": "reportType",
            "type": "EntraRestoreReportReportTypeEnum",
            "format": ""
        },
        {
            "name": "job",
            "baseName": "job",
            "type": "EntraRestoreReportJob",
            "format": ""
        },
        {
            "name": "summary",
            "baseName": "summary",
            "type": "EntraRestoreReportSummary",
            "format": ""
        },
        {
            "name": "entities",
            "baseName": "entities",
            "type": "Array<EntraRestoreReportEntity>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EntraRestoreReport.attributeTypeMap;
    }
    constructor() {
    }
}
export var EntraRestoreReportReportTypeEnum;
(function (EntraRestoreReportReportTypeEnum) {
    EntraRestoreReportReportTypeEnum["EntraIdRestore"] = "ENTRA_ID_RESTORE";
})(EntraRestoreReportReportTypeEnum || (EntraRestoreReportReportTypeEnum = {}));
